import ListNotification, { PATH as LIST_NOTIFICATION } from './ListNotification'

export default { ListNotification }
export const PATH = { LIST_NOTIFICATION }
